import React from 'react';

interface LogoProps {
  size?: number;
}

export function Logo({ size = 48 }: LogoProps): React.ReactElement {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <ellipse cx="25" cy="43.4" rx="11" ry="2.1" fill="#2A1E18" opacity="0.13"/>
      <path d="M15 23 Q9 21 7.6 16.6" stroke="#2A1E18" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="7" cy="15.4" r="2.3" fill="#fff" stroke="#2A1E18" strokeWidth="2"/>
      <path d="M35 25 Q39 27 38.6 31" stroke="#2A1E18" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="38.8" cy="31.6" r="2.3" fill="#fff" stroke="#2A1E18" strokeWidth="2"/>
      <path d="M20 38 L20 41.4" stroke="#2A1E18" strokeWidth="2" strokeLinecap="round"/>
      <path d="M30 38 L30 41.4" stroke="#2A1E18" strokeWidth="2" strokeLinecap="round"/>
      <ellipse cx="18.7" cy="42" rx="2.5" ry="1.5" fill="#fff" stroke="#2A1E18" strokeWidth="1.7"/>
      <ellipse cx="31.3" cy="42" rx="2.5" ry="1.5" fill="#fff" stroke="#2A1E18" strokeWidth="1.7"/>
      <rect x="13" y="8" width="24" height="30" rx="5" fill="#fff" stroke="#2A1E18" strokeWidth="2"/>
      <rect x="17.5" y="12.4" width="15" height="3" rx="1.5" fill="#F47C2C"/>
      <circle cx="18.6" cy="24" r="1.8" fill="#F58A6A" opacity="0.55"/>
      <circle cx="31.4" cy="24" r="1.8" fill="#F58A6A" opacity="0.55"/>
      <circle cx="21" cy="21" r="1.7" fill="#2A1E18"/>
      <circle cx="29" cy="21" r="1.7" fill="#2A1E18"/>
      <circle cx="21.6" cy="20.4" r="0.5" fill="#fff"/>
      <circle cx="29.6" cy="20.4" r="0.5" fill="#fff"/>
      <path d="M21 24.6 Q25 27.6 29 24.6" stroke="#2A1E18" strokeWidth="1.8" strokeLinecap="round"/>
      <rect x="18" y="30.4" width="14" height="1.9" rx="0.95" fill="#0E7C6F"/>
      <rect x="18" y="33.9" width="9" height="1.9" rx="0.95" fill="#A12A4A"/>
    </svg>
  );
}
